import React, { useMemo } from 'react';
import { withTranslation } from 'react-i18next';
import { Tag, TagProps } from 'antd';
import { i18n, TFunction } from 'i18next';

import { TStatusText } from 'containers/Reward/i18n/TModules';

interface StatusTagProps extends TagProps {
  state: string;
  t?: TFunction;
  i18n?: i18n;
  tReady?: boolean;
}

export const StatusTag = ({
  state = 'draft',
  style = {},
  t,
  i18n,
  tReady,
  ...props
}: StatusTagProps) => {
  let color = null;
  switch (state) {
    case 'draft':
    case 'processing':
    case 'reversed':
      color = '#b9b9b9';
      break;
    case 'inactive':
    case 'failed':
    case 'fail':
    case 'timeout':
    case 'expired':
      color = '#c23a34';
      break;
    case 'active':
    case 'success':
    case 'complete':
    case 'completed':
    case 'processed':
    case 'issued':
      color = '#10d994';
      break;
    case 'redeemed':
    case 'errors':
    case 'pending':
      color = '#f5a623';
      break;
    case 'approved':
    case 'scheduled':
      color = '#1295d3';
      break;
    case 'ended':
      color = '#e5e5e5';
      break;
    case 'running':
      color = '#469BFF';
      break;
    default:
      color = '#cccccc';
      break;
  }

  const showStatusTagTranslated = useMemo(() => {
    const text = t(`${TStatusText}.${state}`);
    return text.includes('.') ? state : text;
  }, [t, state]);

  return (
    <Tag
      color={color}
      /* Exposes the state to CSS. antd puts the state colour in an inline background-color, which a
         theme cannot read, so the light-background states cannot otherwise be corrected. Inert. */
      data-state={state}
      {...props}
      style={{
        borderRadius: '1.35rem',
        padding: '0 8px',
        lineHeight: '1.5rem',
        ...style
      }}
    >
      {showStatusTagTranslated}
    </Tag>
  );
};

export default withTranslation()(StatusTag);
